import { Flex, ReadonlyField, SectionTitle } from '@shared/components';

import { QuestionReviewContentPreviewer } from '../../components';
import { QuestionReviewChoiceList } from '../../components/question-review-choice-list';
import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionDetailsView() {
  const { question, mainTaskDetails } = useQuestionReviewTaskQuestionDetails();
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <SectionTitle title='Question' />
      <ReadonlyField
        content={
          <QuestionReviewContentPreviewer
            content={question.details}
            questionId={question.id}
            taskId={mainTaskDetails.id}
          />
        }
      />
      <QuestionReviewChoiceList
        taskId={mainTaskDetails.id}
        questionId={question.id}
        choices={question.metadata.choices}
        value={question.correctAnswer.value}
      />
    </Flex>
  );
}
